import { UserType } from '../profile/profile.model';
import { AzureAdRoles } from './AzureAdRoles';
var VideoPortalUser = /** @class */ (function () {
    function VideoPortalUser(user, profile) {
        this.user = user;
        this.profile = profile;
    }
    Object.defineProperty(VideoPortalUser.prototype, "costPerCameraMinute", {
        get: function () {
            return this.profile.costPerCameraMinute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "councilName", {
        get: function () {
            return this.profile.userType === 'Council' ? this.profile.organisation : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "councilSiteNumber", {
        get: function () {
            return this.profile.councilSiteNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "email", {
        get: function () {
            return this.user.profile.upn || this.user.profile.preferred_username || '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "hasAgreedToTermsAndConditions", {
        get: function () {
            return this.profile.hasAgreedToTermsAndConditions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "isFreeUser", {
        get: function () {
            return this.profile.isFreeUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "name", {
        get: function () {
            return this.user.profile.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "roles", {
        get: function () {
            var idTokenProfileRoles = (this.user.profile && this.user.profile.roles) || [];
            if (!this.profile) {
                return idTokenProfileRoles;
            }
            switch (UserType[this.profile.userType]) {
                case UserType.Council:
                    return idTokenProfileRoles.concat(['council']);
                case UserType.JJR:
                    return idTokenProfileRoles.concat(['jjr']);
                default:
                    return idTokenProfileRoles;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "hasAdminRole", {
        get: function () {
            return this.roles.some(function (r) { return r === AzureAdRoles.AzureActiveDirectoryAdminRole; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "hasCommercialRole", {
        get: function () {
            return this.hasAdminRole ||
                this.roles.some(function (r) { return r === AzureAdRoles.AzureActiveDirectoryViewCommercialRole; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "hasDomesticRole", {
        get: function () {
            return this.hasAdminRole ||
                this.roles.some(function (r) { return r === AzureAdRoles.AzureActiveDirectoryViewDomesticRole; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "hasUserRole", {
        // TODO Decide if we actually need this role.
        get: function () {
            return this.hasAdminRole ||
                this.roles.some(function (r) { return r === AzureAdRoles.AzureActiveDirectoryUserRole; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VideoPortalUser.prototype, "username", {
        get: function () {
            return this.user.profile.upn || this.user.profile.preferred_username || '';
        },
        enumerable: true,
        configurable: true
    });
    VideoPortalUser.prototype.isInRole = function (role) {
        return this.roles.indexOf(role) >= 0;
    };
    return VideoPortalUser;
}());
export { VideoPortalUser };
